import { Tag, TagCloseButton, TagLabel } from '@chakra-ui/react';
import { entries } from 'lodash';
import { tagStyle } from 'shared/styles';
import { IProductTitle, TProductSplit } from 'shared/types';

type TAliasestags = {
    entry: TProductSplit;
    type: keyof IProductTitle;
    aliases: Record<string, string[]>;
    productToUpdate: IProductTitle;
    readonly: boolean;
    setProductToUpdate: React.Dispatch<React.SetStateAction<IProductTitle>>;
};

const AliasesTags = ({ entry, type, aliases, productToUpdate, readonly, setProductToUpdate }: TAliasestags) => {
    const mainVal = `${entry?.val ?? ''}`;
    const displayedAliases: any[] = [];
    const aliasesList = entries(aliases).reduce(
        (prev, [k, list]) => (mainVal.toUpperCase() === k.toUpperCase() ? [...prev, ...list] : prev),
        [] as string[],
    );

    const handleRemoveAlias = (alias: string, key: keyof IProductTitle) => {
        const entry = { ...(productToUpdate[key] as TProductSplit) };
        if (entry.aliases?.includes(alias)) {
            if (entry.minus) {
                entry.minus = [...entry.minus];
                entry.minus.push(alias);
            } else {
                entry.minus = [alias];
            }
        } else {
            entry.plus = entry.plus?.filter((el) => el !== alias);
        }

        setProductToUpdate({ ...productToUpdate, [key]: entry } as IProductTitle);
    };

    const handleRemoveNameSplit = (key: keyof IProductTitle) => {
        setProductToUpdate({ ...productToUpdate, [key]: { val: '' } } as IProductTitle);
    };

    if (entry && entry.plus) {
        entry.plus.forEach((aliasP) =>
            displayedAliases.push(
                <Tag key={aliasP} {...tagStyle} bgColor="red.300" size="sm" my={1} mr={1}>
                    <TagLabel>{aliasP}</TagLabel>
                    {!readonly && <TagCloseButton onClick={() => handleRemoveAlias(aliasP, type)} />}
                </Tag>,
            ),
        );
    }

    if (aliasesList?.length) {
        aliasesList.forEach((alias) =>
            displayedAliases.push(
                <Tag key={alias} {...tagStyle} size="sm" my={1} mr={1}>
                    <TagLabel>{alias}</TagLabel>
                </Tag>,
            ),
        );
    }

    return (
        <>
            {mainVal && (
                <Tag {...tagStyle} size="sm" bgColor="yellow.400" my={1} mr={1}>
                    {mainVal}
                    {!readonly && <TagCloseButton onClick={() => handleRemoveNameSplit(type)} />}
                </Tag>
            )}
            {entry && displayedAliases}
        </>
    );
};

export default AliasesTags;
